import template from './FlagIcon.html';

export default {
	template,
	props: ['geo'],
	computed: {
		cc() {
			let code = (this.geo || '').toLowerCase();
			if (code === 'uk') {
				code = 'gb';
			}
			return code;
		}
	}
};